import React from 'react';

const AJAX_XMLHttp = () => {
  return (
    <div >
      <h1>AJAX_XMLHttp</h1>
      <p>Placeholder component for: "AJAX XMLHttp"</p>
    </div>
  );
};

export default AJAX_XMLHttp;
